var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17L17 10L20 13L13 20L10 17Z",
    fill: "url(#paint0_radial_1416_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L14.5 3.5L0 0L3.5 14.5L11 16L16 11Z",
    fill: "url(#paint1_radial_1416_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L7.586 7.586Z",
    fill: "url(#paint2_radial_1416_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z",
    fill: "url(#paint3_radial_1416_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1416_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80645 -20 18.9779 4.8621 7.09677 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1416_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80645 -20 18.9779 4.8621 7.09677 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1416_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80645 -20 18.9779 4.8621 7.09677 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1416_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80645 -20 18.9779 4.8621 7.09677 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.45d2d1feb5e93116a8ed614b256d189a.svg";
export { ForwardRef as ReactComponent };